import { render, staticRenderFns } from "./BaseEdit.vue?vue&type=template&id=6762af55"
import script from "./BaseEdit.vue?vue&type=script&lang=js"
export * from "./BaseEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports